import * as ActionTypes from 'constants';

const jobs = (state = {
  //Storage
  downloaded_jobs : [],
  current_job : '',
  previewing_job : '',

  //Filters
  keywords : '',
  current_filters : [],
  available_filters : [],

  //States
  show_create_job : false,
  show_delete_job_confirm : false,

  //Loaders
  creating_job : false,
  deleting_job : false,
  downloading_filters : false,
  downloading_jobs : false,
  creating_job : false,
  updating_job : false,

  //Api trackers.
  offset : 0,
  size : 50,
  total : 0,
  sort: '-number'
}, action) => {
  const { payload, type } = action;
  const { downloaded_jobs } = state;
  switch( type ) {
    case ActionTypes.SET_JOBS_SORT_COLUMN:
      return { ...state, sort: payload.sort }
    case ActionTypes.SHOW_DELETE_JOB_CONFIRM :
      return {...state, show_delete_job_confirm : payload !== undefined ? payload : !state.show_delete_job_confirm}
    case ActionTypes.UPDATE_JOB_KEYWORDS:
      return {
        ...state,
        keywords : payload.keywords
      }
    case ActionTypes.SET_CURRENT_JOB:
      return {
        ...state,
        current_job : payload.id
      }
    case ActionTypes.FETCH_JOBS: case ActionTypes.FETCH_NEXT_JOBS:
      return {
        ...state,
        downloading_jobs : true
      }
    case ActionTypes.FETCH_JOBS_SUCCESS:
      return {
        ...state,
        downloading_jobs : false,
        sort: payload.sort? payload.sort : state.sort,
        size : payload.size,
        offset : payload.offset,
        total : payload.total,
        size: payload.size,
        downloaded_jobs : payload.results.map(item => job_container(null , {
          type: ActionTypes.ADD_JOB,
          payload : { job : item }
        }))
      }
    case ActionTypes.FETCH_JOBS_FAILED:
      return {
        ...state,
        downloading_jobs : false
      }
    case ActionTypes.FETCH_NEXT_JOBS_SUCCESS:
      return {
        ...state,
        downloading_jobs : false,
        downloaded_jobs : [
          ...state.downloaded_jobs,
          ...payload.results.map(item => job_container(null, {
            type: ActionTypes.ADD_JOB, payload : { job : item }
          }))
        ],
        size : payload.size,
        offset : payload.offset,
        total : payload.total
      }
    case ActionTypes.FETCH_NEXT_JOBS_FAILED:
      return {
        ...state,
        downloading_jobs : false,
      }
    case ActionTypes.FETCH_JOBS_FILTERS:
      return {
        ...state,
        downloading_filters : true
      }
    case ActionTypes.FETCH_JOBS_FILTERS_SUCCESS: case ActionTypes.FETCH_JOBS_FILTERS_FAILED:
      return {
        ...state,
        available_filters : payload && payload.filters ? payload.filters : [],
        downloading_filters : false
      }
    case ActionTypes.START_CREATING_JOB:
      return {
        ...state,
        show_create_job: true,
      }
    case ActionTypes.HIDE_CREATE_JOB:
      return {
        ...state,
        show_create_job : false,
      }
    case ActionTypes.CREATE_JOB:
      return {
        ...state,
        creating_job : true
      }
    case ActionTypes.CREATE_JOB_SUCCESS:
      return {
        ...state,
        show_create_job : false,
        creating_job : false,
        downloaded_jobs : [job_container(null, {type : ActionTypes.ADD_JOB, payload : { job : payload.job }}), ...state.downloaded_jobs]
      }
    case ActionTypes.TOGGLE_JOBS_FILTER:
      const exists = state.current_filters.find(({value}) => value == payload.filter.value) ? true : false;
      return {
        ...state,
        current_filters : exists ? [
          ...state
            .current_filters
            .filter(({value}) => value != payload.filter.value)
        ] : [
          ...state.current_filters,
          payload.filter
        ]
      }
    case ActionTypes.PREVIEW_JOB:
      return {
        ...state,
          previewing_job : state.downloaded_jobs.find(job_container => (job_container.job._id == action.payload.id)) ? action.payload.id : '',
      }
    case ActionTypes.SELECT_JOB:
    case ActionTypes.DESELECT_JOB:
      return {
        ...state,
        downloaded_jobs : state.downloaded_jobs.map(job => job_container(job, action)),
      }
    case ActionTypes.ADD_JOB:

      return {
        ...state,
        downloaded_jobs : [
          job_container(null, action),
          ...downloaded_jobs
          .filter(({ job }) => (job._id != payload.job._id))
        ]
      }
    case ActionTypes.REMOVE_JOB:
      return {
        ...state,
        downloaded_jobs : [
          ...downloaded_jobs
          .filter(({ job : { _id : id } }) => (id != payload.job || payload.id || payload._id))
        ]
      }
    case ActionTypes.UPDATE_JOB:
      return {
        ...state,
        downloaded_jobs : [
          ...downloaded_jobs
          .map(item => job_container(item, action))
        ]
      }
    case ActionTypes.CLEAR_DOWNLOADED_JOBS:
      return {
        ...state,
        downloaded_jobs : [],
        previewing_job : '',
      }
    default:
      return {
        ...state,
        downloaded_jobs : state.downloaded_jobs.map(item => (job_container(item, action)))
      }
  }
}

const job = (state = {}, action) => {
  const { payload, type } = action;
  switch ( type ) {
    case ActionTypes.UPDATE_JOB:
      if(payload.job._id == state._id) {
        return {
          ...state,
          ...payload.job
        }
      }
  }
  return state;
}

const job_container = (state = {
  selected : false,
  job : null,
}, action) => {
  const { payload, type } = action;

  switch( type ) {
    case ActionTypes.ADD_JOB:
      return {
        ...state,
        job : job(payload.job, action)
      }
    case ActionTypes.SELECT_JOB:
      if(job._id == (payload.id || payload._id)) {
        return {
          ...state,
          selected : true
        }
      }
    case ActionTypes.DESELECT_JOB:
      if(job._id == (payload.id || payload._id)) {
        return {
          ...state,
          selected : false
        }
      }
    default:
      return {
        ...state,
        job : job(state.job, action)
      }
  }
  return state;
}

export {jobs};



// WEBPACK FOOTER //
// ./src/common/reducers/jobs.js